import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const testEmployeeRequirementUpdatedWebhook = (
  axios: IAxiosInstance
) => {
  return async ({
    url,
    testMode,
  }: ISchema["#/definitions/ITestEmployeeRequirementUpdatedWebhookBody"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ITestEmployeeRequirementUpdatedWebhookResponse"]
    >(`/api/testEmployeeRequirementUpdatedWebhook`, {
      url,
      testMode,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
